"use client";

import { Sparkles, ShieldCheck, Target } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Conciergeservicetiers() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const treatments = [{
    icon: Sparkles,
    title: "Elite Events",
    description: "Weddings, galas, and private parties curated for a flawless experience – from planning to on-site execution, ensuring every detail reflects your vision.",
    to: "/ExperiencePage"
  }, {
    icon: Target,
    title: "Corporate & On-Site Business Services",
    description: " Host on-site wellness events to drive foot traffic, gain high-value customers through cross-pollination, and boost your brand's social buzz.",
    to: "/ExperiencePage"
  }, {
    icon: ShieldCheck,
    title: "VIP In-Home & Mobile Services",
    description: "Personalized, private treatments delivered to your home or office, offering convenience, privacy, and premium results on your schedule.",
    to: "/ExperiencePage"
  }];
  return <section data-section-id="9910" id="conciergeservicetiers" className="bg-background py-28 md:py-40">
      <div className="mx-auto w-full max-w-[1240px] px-6 md:px-8">
        <div ref={headerRef} className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8" style={{
        opacity: headerVisible ? 1 : 0,
        transform: headerVisible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 700ms cubic-bezier(0.22, 0.61, 0.36, 1), transform 700ms cubic-bezier(0.22, 0.61, 0.36, 1)"
      }}>
          <div className="lg:col-span-7">
            <h2 className="font-default text-foreground" style={{
            fontSize: "clamp(2.125rem, 4vw, 3.5rem)",
            fontWeight: 700,
            letterSpacing: "-0.018em",
            lineHeight: 1.1
          }}>
              Concierge{" "}
              <em className="font-default italic" style={{
              fontWeight: 400
            }}>
                Service Types
              </em>
            </h2>
          </div>

          <div className="lg:col-span-5 lg:pt-2">
            <p className="font-default text-muted-foreground" style={{
            fontSize: "clamp(1.125rem, 1.3vw, 1.3125rem)",
            fontWeight: 400,
            letterSpacing: "-0.003em",
            lineHeight: 1.65
          }}>
              Our concierge approach brings premium medical aesthetics directly to your environment. We prioritize seamless integration into your lifestyle, ensuring privacy, convenience, and exceptional results tailored to your specific needs.
            </p>
            <div className="mt-8">
              <Link to="/ExperiencePage" className="group inline-flex items-center font-default text-accent-foreground underline decoration-accent-foreground underline-offset-4 transition-[text-decoration-thickness] duration-200 hover:decoration-2" style={{
              fontWeight: 500
            }}>
                Explore our services →
              </Link>
            </div>
          </div>
        </div>

        <div ref={gridRef} className="mt-20 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 lg:grid-cols-3">
          {treatments.map((item, i) => {
          const Icon = item.icon;
          const buttonText = i === 0 ? "Explore Elite Events" : i === 1 ? "Explore Corporate Services" : "Explore VIP Services";
          return <Card data-index={i} key={i} className="group flex flex-col bg-card p-8 shadow-md rounded-lg transition-all duration-[350ms] ease-out hover:-translate-y-0.5 hover:shadow-lg" style={{
            opacity: gridVisible ? 1 : 0,
            transform: gridVisible ? "translateY(0)" : "translateY(16px)",
            transition: `opacity 700ms cubic-bezier(0.22, 0.61, 0.36, 1) ${i * 80}ms, transform 700ms cubic-bezier(0.22, 0.61, 0.36, 1) ${i * 80}ms, box-shadow 350ms cubic-bezier(0.22, 0.61, 0.36, 1)`
          }}>
                <div className="flex flex-1 flex-col">
                  <Icon className="size-7 text-accent-foreground" strokeWidth={1.5} />
                  <h3 className="font-default mt-8 text-foreground" style={{
                fontSize: "clamp(1.125rem, 1.4vw, 1.375rem)",
                fontWeight: 600,
                letterSpacing: "-0.005em",
                lineHeight: 1.3
              }}>
                    {item.title}
                  </h3>
                  <p className="font-default mt-4 flex-1 text-muted-foreground" style={{
                fontSize: "1rem",
                fontWeight: 400,
                lineHeight: 1.7
              }}>
                    {item.description}
                  </p>
                  <div className="mt-8">
                    <Button asChild>
                      <Link to={i === 2 ? "https://my.portraitcare.com/booking/?business_id=jr3uOp" : item.to} target={i === 2 ? "_blank" : undefined}>
                        {buttonText}
                      </Link>
                    </Button>
                  </div>
                </div>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}